export function isOpen24By7(opening_hours?: {
  periods?: any[];
  weekday_text?: string[];
}): boolean {
  if (!opening_hours) return false;

  // Checa por texto "Open 24 hours" nos 7 dias
  const allDays24h =
    opening_hours.weekday_text?.length === 7 &&
    opening_hours.weekday_text.every((text) =>
      text.toLowerCase().includes("open 24 hours")
    );

  // Checa se periods tem só 1 item com open às 00:00 no domingo (0)
  const period24h =
    opening_hours.periods?.length === 1 &&
    opening_hours.periods[0].open?.day === 0 &&
    opening_hours.periods[0].open?.time === "0000" &&
    !opening_hours.periods[0].close;

  return allDays24h || period24h;
}

export function formatHour(hora: number): string {
  const horaStr = hora.toString().padStart(4, "0");
  const horas = parseInt(horaStr.slice(0, 2));
  const minutos = horaStr.slice(2);

  const periodo = horas >= 12 ? "PM" : "AM";
  const horas12 = horas % 12 === 0 ? 12 : horas % 12;

  return `${horas12.toString().padStart(2, "0")}:${minutos} ${periodo}`;
}
